import request from '../request';

export default {
  // 首页-统计列表
  index(data) {
    return request.get('/basic/index', data);
  },

  // 首页-饼图数据
  analyse(data) {
    return request.get('/basic/analyse', data);
  },

  // 折线统计-导出excel
  downloadTable(data) {
    return request.get('/basic/downloadTable', data);
  },
};
